import React, { useState } from "react";
import { useMessageSource } from "react-message-source";
import { FundsOwnership as FundsOwnershipType } from "../../../api/commercial/generated-types";
import RadioButtonField from "../../shared/components/formik/radiobutton";
import { RadioButtonItem } from "../../../ui/widgets/radiobutton/types";
import InputContainer from "../../../ui/layout/page/forms-container/form-item-container/input-container";
import FirstName from "../../shared/components/first-name";
import LastName from "../../shared/components/last-name";
import AddressSelect from "../../shared/components/address-select";
import CountryFieldContainer from "../../../ui/layout/page/forms-container/form-item-container/country-field-container";
import { FundsOwnershipCardholderModel } from "./types";
import Nationality from "../../shared/components/nationality";
import FormContainer from "../../../ui/layout/page/forms-container/form-base-container";
import Gender from "../../shared/components/gender";
import BirthDate from "../../shared/components/birth-date";
import Country from "../../shared/components/country";

interface FundsOwnershipProps {
  cardholder: FundsOwnershipCardholderModel;
  value: FundsOwnershipType;
}

const FundsOwnership = ({
  cardholder,
  value,
}: FundsOwnershipProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const [selectedOption, setSelectedOption] =
    useState<FundsOwnershipType>(value);

  const radioButtonValues: RadioButtonItem<FundsOwnershipType>[] = [
    {
      id: "funds-ownership-admin",
      value: FundsOwnershipType.ADMIN,
      label: getMessage("Cardholder.fundsOwnership-admin"),
    },
    {
      id: "funds-ownership-company",
      value: FundsOwnershipType.COMPANY,
      label: getMessage("Cardholder.fundsOwnership-company"),
    },
    {
      id: "funds-ownership-employee-and-company",
      value: FundsOwnershipType.ADMIN_AND_COMPANY,
      label: getMessage("Cardholder.fundsOwnership-employee-and-company"),
    },
    {
      id: "funds-ownership-other",
      value: FundsOwnershipType.OTHER,
      label: getMessage("Cardholder.fundsOwnership-other"),
    },
  ];

  return (
    <>
      <InputContainer>
        <RadioButtonField
          title={getMessage("Cardholder.fundsOwnership.info")}
          values={radioButtonValues}
          id="decentralizedInvoicing.fundsOwnership"
          name="decentralizedInvoicing.fundsOwnership"
          onChangeCallback={(_, value) => {
            setSelectedOption(value);
          }}
        />
      </InputContainer>
      {selectedOption === "OTHER" && (
        <FormContainer>
          <InputContainer>
            <Gender dataPath="fundsOwnershipCardholder." />
          </InputContainer>
          <InputContainer>
            <FirstName
              dataPath="fundsOwnershipCardholder."
              value={cardholder.firstName}
            />
          </InputContainer>
          <InputContainer>
            <LastName
              dataPath="fundsOwnershipCardholder."
              value={cardholder.lastName}
            />
          </InputContainer>
          <InputContainer>
            <BirthDate
              dataPath="fundsOwnershipCardholder."
              value={cardholder.birthdate}
            />
          </InputContainer>
          <CountryFieldContainer>
            <Nationality
              dataPath="fundsOwnershipCardholder."
              value={cardholder.nationality}
            />
          </CountryFieldContainer>
          <AddressSelect
            dataPath="fundsOwnershipCardholder."
            fullStreet={cardholder.fullStreet}
            address={cardholder.address}
          />
          <CountryFieldContainer>
            <Country
              dataPath="fundsOwnershipCardholder."
              value={cardholder.address.country}
            />
          </CountryFieldContainer>
        </FormContainer>
      )}
    </>
  );
};

export default FundsOwnership;
